<template>
    <div class="container">
        <b-form-group label="Loại liên hệ">
        <b-form-radio-group
            id="type-group-1"
            v-model="selected_type"
            :options="type_enums"
            name="type-options"
        ></b-form-radio-group>
        </b-form-group>

        <b-textarea v-model="chat.message"></b-textarea>
        <b-button variant="primary" @click="submitChat" class="ml-2">Gửi</b-button>

        <div>
            <p v-if="isLoading" style="color: blue">Đang thao tác với dữ liệu...</p>
            <hr/>
            <div v-for="(chat, index) in messages" v-bind:key="chat.id">
                <div class="row">
                    <div class="col-10 col-md-10">
                        <p><span class="text-bold">{{chat.created_by?chat.created_by:'User'}}</span> - {{formatDateTime(chat.created_at)}}</p>
                        
                        <p v-if="!chat.edit" class="log-textarea">
                            <span v-if="chat.type">[{{convertTypeValueToTypeLabel(chat.type)}}]</span>
                            {{chat.description}}
                        </p>
                        <div v-else>
                            <textarea type="text" v-model="currentEditMessage" :ref="'curMessageRef'" rows="5" cols="68"></textarea>
                            <b-button variant="success" size="sm" @click="updateMessage(index)">Update</b-button>
                        </div>
                    </div>
                    <div class="col-2 col-md-2">
                        <b-button variant="info" size="sm" @click="enableEdit(index)">Edit</b-button>
                        <b-button variant="danger" size="sm" @click="removeMessage(index)">Delete</b-button>
                    </div>
                </div>
                <hr/>
            </div>
        </div>
    </div>

</template>

<script>

import ClientChatService from './ClientChatService'
import Firebase from '@/services/firebase'
import moment from 'moment'

export default {
  name: 'ClientChatLogs',
  props: ['clientId'],
  components: {

    },
  data () {
    return {
        isLoading: false,
        chat: {
            message: '',
            type: '', // Gặp, Gởi tài liệu, Gọi, KH Gọi, Nhắn KH, KH Nhắn
            created_by: '',
            created_at: null
        },
        chatService: null,
        messages: [],
        selected_type: 'Goi',
        currentEditMessage: '',
        type_enums: [
            { value:'Gap', text: 'Gặp'}, 
            { value:'Goi', text: 'Gọi'},
            { value:'Nhan KH', text: 'Nhắn KH'},
            { value:'KH Goi', text: 'KH Gọi'},
            { value:'KH Nhan', text: 'KH Nhắn'},
            { value:'Goi tai lieu', text: 'Gởi tài liệu'}
        ]
    }
  },
  computed: {

  },
  watch: {
      clientId: function(newVal, oldVal) { // watch it
        this.refreshChatMessage();
      }
  },
  methods: {
      formatDateTime(v) {
          return moment(v).format('DD/MM/YYYY hh:mm:ss')
      },
    resetChatForm () {
        this.chat.message = '';
    },

    convertTypeValueToTypeLabel(value) {
        for(var i=0; i<this.type_enums.length; i++) {
            if(this.type_enums[i].value === value)
                return this.type_enums[i].text;
        }

        return '';
    },

    async submitChat () {
        var _message = this.chat.message.replace(/\r\n|\r|\n/g,"<br>");
        await this.chatService.submitLogEntry(this.clientId, this.chat.created_by, _message, this.selected_type);

        this.resetChatForm();

        this.refreshChatMessage();
    },

    async refreshChatMessage () {
        if(!this.clientId || this.clientId === 'null') 
            return;
            
        var _messages = await this.chatService.listAllByClient(this.clientId);
        this.messages = _messages.map(msg => {return {...msg, edit: false, description: msg.description.replaceAll("<br>","\n")}});
    },

    enableEdit (index) {
        this.messages.forEach((message, idx) => {
            if (idx === index)
                message.edit = true;
            else {
                message.edit = false;
            }
        });

        this.$nextTick(() => {
            let input = this.$refs.curMessageRef[0];
            this.currentEditMessage = this.messages[index].description;
            input.focus();
        });
    },

    async updateMessage (index) {
        this.isLoading = true;

        var _message = this.currentEditMessage.replace(/\r\n|\r|\n/g,"<br>")
        await this.chatService.updateLogEntry(this.messages[index].id, _message);

        this.refreshChatMessage();

        this.isLoading = false;
    },

    async removeMessage(index) {
        var r = confirm("Thao tác xoá sẽ không thể phục hồi lại. Bạn có muốn xoá dữ liệu?");
        if (r == true) {
            
        } else {
            return;
        }

        this.isLoading = true;

        await this.chatService.removeLogEntry(this.messages[index].id);
        this.refreshChatMessage();

        this.isLoading = false;
    }
  },
  mounted () {
      Firebase.auth.onAuthStateChanged( user => {
        if (user) {
            this.chat.created_by = user.email;
        }
      })

    this.chatService = new ClientChatService();
    
    this.refreshChatMessage();
  }
}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

.log-textarea {
    white-space: pre-wrap !important;
}

hr.dashed {
  border-top: 3px dashed #bbb;
}
</style>

